import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { UsersService } from '@app/modules/users/services/users.service';

import { companyUserDetails, companyUsers } from '@app/modules/dashboard/mocks/users.data';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return usersBackend(req.url, req.method, req.body) || next.handle(req);
  }
}

export function usersBackend(url: string, method: string, body: any): Observable<HttpEvent<any>> {
  if (url.endsWith(`${UsersService.API_USERS_BASE_PATH}`) && method === 'GET') {
    return new Observable(resp => {
      resp.next(new HttpResponse<any>({
        status: 200,
        body: companyUsers
      }));
      resp.complete();
    });
  }

  if (url.endsWith(`${UsersService.API_USERS_BASE_PATH}/1`) && method === 'GET') {
    return new Observable(resp => {
      resp.next(new HttpResponse<any>({
        status: 200,
        body: companyUserDetails
      }));
      resp.complete();
    });
  }

  if (url.endsWith(`${UsersService.API_USERS_BASE_PATH}/1`) && method === 'PATCH') {
    return new Observable(resp => {
      resp.next(new HttpResponse<any>({
        status: 200,
        body
      }));
      resp.complete();
    });
  }
}
